import {apiPost} from './api.client';
import {getSiteHeader} from './siteHeaderUtils';

let aamClient = (function() {
    let deviceList = [];
    let siteName = null;

    function apiPostSetup(path, payload, headers) {
        if (deviceList) {
            payload.devices = deviceList;
        }
        return apiPost(path, payload, headers);
    }

    let setup = function(devices, site) {
        if (Array.isArray(devices)) {
            deviceList = devices;
        }
        siteName = site;
        return Promise.resolve(deviceList, siteName);
    };

    let getDevices = function() {
        return deviceList;
    };

    let authenticate = function(payload) {
        return apiPostSetup('/auth/aam/v3/authenticate', payload, getSiteHeader(siteName));
    };

    let passwordChange = function(payload) {
        return apiPostSetup('/auth/aam/v3/password/change', payload, getSiteHeader(siteName));
    };

    let refreshLogin = function() {
        return apiPostSetup('/auth/aam/v3/refreshlogin', {}, getSiteHeader(siteName));
    };

    return {
        getDevices,
        setup,
        authenticate,
        passwordChange,
        refreshLogin
    };
}());

export default aamClient;
